module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/amex-955429900906675cf83034d1170971ef.svg";